<!--
  详情页 - 通话记录
  props:
    id: 详情id
  emit:
    openDetail: 打开详情页
 -->

<template>
	<div class="v-tabs notes-list">
		<div class="head">
      <div class="total">
        通话记录({{page.total}}次)
      </div>
    </div>
    <div class="content" ref="content">
      <ul class="call-list">
        <li class="item center" v-if="!tableData.length">暂无数据</li>
        <li class="item" v-for="(item, index) in tableData">
          <div class="date" v-if="showDate(index)">
            <span class="text">{{item.callTimeShow | onlyDate}}</span>
          </div>
          <div class="infos">
            <div class="target">
              <span class="icon">
                <i class="web-icon-callin" v-if="!item.type"></i>
              </span>
              <span class="name" v-if="item.refType === 3 && moduleName !== 'contactApi'" @click="openDetail(item.refId)">{{item.refName}}</span>
              <span v-else>{{item.refName}}</span>
            </div>
            <div class="duration">
              <span v-if="item.result">
                {{item.duration | formatTime}}
              </span>
              <span v-else class="red">
                通话失败
              </span>
            </div>
            <div class="call-time">{{item.callTimeShow | onlyTime}}</div>
            <div class="options">
              <audio
                v-if="item.recordUrl"
                class="audio"
                controls="controls"
                :src="item.recordUrl">
              </audio>
              <span v-else>无</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.pageSize">没有更多</template>
    </div>
	</div>
</template>

<script>
import * as api from 'src/api'
import { LS } from 'assets/js/storage'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    moduleName: {
      type: String,
      default: 'customerApi'
    },
    loading: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      tableData: [],
      date: [],
      // 分页信息
      page: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        rows: 1
      },
      moduleType: Number(LS.get('VUE-CTI-moduleType')) // 获取呼叫中心的moduleType
    }
  },
  computed: {

    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.pageSize && this.page.rows > this.page.currentPage) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    datepicker (val) {
      this.page.currentPage = 1
      if (val) {
        this.date = val.split(' - ')
      } else {
        this.date = []
      }
      this.getList()
    },
    openDetail (refId) {
      this.$emit('openDetail', 'contactApi', refId)
    },
    // 获取通话记录
    getList () {
      const url = '/callcenter/callLog/list.do'
      let params = {
        moduleType: this.moduleType,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        refId: this.id
      }

      if (this.moduleName === 'customerApi') {
        params.refType = 2
      } else if (this.moduleName === 'contactApi') {
        params.refType = 3
      } else {
        console.warn('Cant find moduleName on /components/detail/call-log.vue')
      }

      api.post(url, params, (data) => {

        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.currentPage === 1) {
          this.tableData = data.result.callLogList
        } else {
          this.tableData = this.tableData.concat(data.result.callLogList)
        }
        this.page.total = data.result.totalElements
        this.page.rows = data.result.totalPages
      })
    },
    // 加载更多
    loadmore () {
      this.page.currentPage++
      this.getList()
    },

    // 是否显示日期
    showDate (index) {
      if (index) {
        let a = this.tableData[index].callTimeShow.slice(0, 10)
        let b = this.tableData[index - 1].callTimeShow.slice(0, 10)
        if (a === b) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }
  },

  filters: {

    // 格式化时间
    formatTime (seconds) {
      let hour = parseInt(seconds / 3600)
      let minite = parseInt((seconds % 3600) / 60)
      let second = (seconds % 3600) % 60

      // 对于个数位，前面补0
      function addZero (origin) {
        if (origin < 10) {
          return '0' + origin
        } else {
          return origin
        }
      }

      return `${addZero(hour)}:${addZero(minite)}:${addZero(second)}`
    },

    // 只保留日期
    onlyDate (date) {
      if (date) {
        return date.slice(0, 10)
      } else {
        return date
      }
    },

    // 只保留时间
    onlyTime (date) {
      if (date) {
        return date.slice(-8)
      } else {
        return date
      }
    }
  },

  watch: {
    loading () {
      if (this.page.rows > this.page.currentPage) {
        this.loadmore()
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';

  .notes-list {
    .call-list {
      .item {
        .date {
          position: relative;
          height: 24px;
          margin-top: 10px;
          &:before {
            position: absolute;
            content: "";
            height: 8px;
            width: 100%;
            background-color: #d5d5d5;
            left: 0;
            top: 5px;
          }
          .text {
            position: absolute;
            background-color: #fff;
            padding: 0 5px;
            line-height: 1;
            top: 3px;
            left: 10px;
            font-size: 13px;
          }
        }
        .infos {
          line-height: 32px;
          font-size: 0;
          padding-bottom: 6px;
          .target {
            display: inline-block;
            vertical-align: top;
            width: 200px;
            font-size: 13px;
            .icon {
              width: 20px;
              display: inline-block;
              font-size: 14px;
            }
            .name {
              color: @primary;
              cursor: pointer;
            }
          }
          .duration {
            display: inline-block;
            vertical-align: top;
            width: 90px;
            font-size: 13px;
            .red {
              color: @bg-red;
            }
          }
          .call-time {
            display: inline-block;
            vertical-align: top;
            width: 90px;
            font-size: 13px;
          }
          .options {
            display: inline-block;
            vertical-align: top;
            width: 240px;
            font-size: 13px;
            color: #999;
            .audio {
              vertical-align: top;
              width: 100%;
            }
          }
        }
        &.center {
          text-align: center;
          line-height: 3;
          color: #999;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// call-log.vue?e83e36de